<template>

    <div class="container">
      

       <!--[start] MODAL PROMPTS -->
        <b-modal id="modal-user-prompt"  :title="userPromptTitle" size="lg" 
            content-class="esi-modal" 
            :header-bg-variant="headerBgVariant" 
            no-close-on-esc no-close-on-backdrop hide-header-close>

            <div class="modal-body"> 
                <div class="alert alert-danger" role="alert">
                    <div class="row">
                        <div class="col-1 pt-3 pb-2 text-right">
                            <b-icon scale="2.5" icon="exclamation-circle"></b-icon>
                        </div>
                        <div class="col-11 pl-4">
                            <div class="mt-2 small">
                                <span class="text-center" v-html="userPromptMessage"></span>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div class="container text-center">
                    <b-button variant="primary" @click="backToMemberHome()">I Agree and take me back to homepage</b-button>
                </div>
            </template>
        </b-modal>
        <!--[end] MODAL ABSENT -->


        <!--[start] MODAL ABSENT -->
        <b-modal id="modal-user-absent"  :title="userPromptTitle" 
            content-class="esi-modal" 
            :header-bg-variant="headerBgVariant" 
            no-close-on-esc no-close-on-backdrop hide-header-close>

            <div class="modal-body">      
                <div class="alert alert-danger" role="alert">
                    <div class="row">
                        <div class="col-1 pt-3 pb-2 text-right">
                            <b-icon scale="2.5" icon="exclamation-circle"></b-icon>
                        </div>
                        <div class="col-11 pl-4">
                            <div class="mt-2 small">
                                <span class="text-center" v-html="userPromptMessage"></span>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>

            <template #modal-footer>
                <div class="container text-center" v-if="is_broadcaster == true">
                    <b-button variant="primary" @click="markStudentAbsent()">
                        Yes, I Confirm to mark my student as absent
                    </b-button>
                     <b-button variant="danger" @click="triggerLimitOverrideAndCallUser()">Call Student</b-button>
                </div>
                <div class="container text-center" v-else>
                    <b-button variant="primary" @click="backToMemberHome()">Okay, Take me back to homepage</b-button>
                </div>                
            </template>
        </b-modal>
        <!--[end] MODAL ABSENT -->


        <!--[start] MODAL EXIRED -->
        <b-modal id="modal-expired" :title="expiredModalTitle" size="lg" 
            content-class="esi-modal" 
            :header-bg-variant="headerBgVariant" 
            no-close-on-esc no-close-on-backdrop hide-header-close>                      

            <div class="alert alert-danger" role="alert">
                <div class="row">
                    <div class="col-1 pt-3 text-right">
                        <b-icon scale="3.5" icon="exclamation-circle"></b-icon>
                    </div>
                    <div class="col-11 pl-4">
                        <div class="mt-2 small font-weight-bold">
                            <span v-html="expiredModalMessage"/>
                        </div>
                        <div class="mt-2 small">This lesson will be counted after clicking I agree button</div>  
                    </div>
                </div>
            </div>

            <template #modal-footer>
                <div class="container text-center">
                    <b-button variant="success" @click="triggerEndSession()">
                        I Agree and take me back to homepage
                    </b-button>
                </div>
            </template>
        </b-modal>
        <!--[end] MODAL EXIRED -->

       <!--[start] MODAL EXIRED -->
        <b-modal id="modal-expired-options" :title="expiredModalTitle" size="lg" 
            content-class="esi-modal" 
            :header-bg-variant="headerBgVariant" 
            no-close-on-esc no-close-on-backdrop hide-header-close>                      

            <div class="alert alert-danger" role="alert">
                <div class="row">
                    <div class="col-1 pt-3 text-right">
                        <b-icon scale="3.5" icon="exclamation-circle"></b-icon>
                    </div>
                    <div class="col-11 pl-4">
                        <div class="mt-2 small font-weight-bold">
                            <span v-html="expiredModalMessage"/>
                        </div>
                        <div class="mt-2 small">This lesson will be counted after ending session</div>  
                    </div>
                </div>
            </div>

            <template #modal-footer>
                <div class="container text-center">
                    <b-button variant="danger" @click="triggerContinueSession()">Continue Session</b-button>    
                    <b-button variant="success" @click="triggerEndSession()">End Session</b-button>                                                                           
                </div>
            </template>
        </b-modal>
        <!--[end] MODAL EXIRED -->

        <b-modal id="modal-completed" title="Your lesson has been completed" size="lg" 
            content-class="esi-modal" 
            :header-bg-variant="headerBgVariant" 
            no-close-on-esc no-close-on-backdrop hide-header-close>                      
            Modal completed
        </b-modal>

        <b-modal id="modal-call-user"  :title="'Calling Student Please wait'" 
            content-class="esi-modal" 
            :header-bg-variant="headerBgVariant" 
            no-close-on-esc no-close-on-backdrop hide-header-close>
             <div v-if="timeLimitExpired == true">
                <div>Time is up the student did not show on time for the lesson</div>
                <div>This lesson is counted please click to confirm.</div>
            </div>
            <div v-else-if="callAttemptFailed == false">
            
                <div class="text-center">                    
                    <span class="text-primary small">
                         <div class="py-2">Sending student a lesson invitation, please wait</div>

                         <b-spinner v-for="variant in variants" :variant="variant" :key="variant"></b-spinner>  

                    </span>
                </div>
            </div>           
            <div v-else-if="callAttemptFailed == true">
                We called several times but the user did not answer
                Would you like to mark this student absent or a no show?
            </div>

            <template #modal-footer>
                <div class="container text-center">
                    <div v-if="callAttemptFailed == true || timeLimitExpired == true">                
                       <b-button variant="primary"  @click="markStudentAbsent()">
                            Yes, I Confirm to mark my student as absent
                        </b-button>
                    </div>                    
                    
                    <div v-else-if="callAttemptFailed == false">
                        <span v-if="redialTimer > 5 ">Connecting....</span>
                        <span v-if="redialTimer >= 1 && redialTimer <= 5">Redialing in {{ redialTimer }} seconds </span>
                        <div class="redial-wrapper" v-if="redialTimer == 0 "> 
                            Please wait while we are redialing ... 
                            <div class="attemp-container">(attempt {{ redialCounter }}) </div>
                        </div>
                    </div>                                                       
                </div>
            </template>
        </b-modal>



        <!-- 
            /*************************************************** 
                            CALL WAITING FOR PARTICIPANTS
            ***************************************************/
        -->
        <b-modal id="show-modal-participants" :title="modalTitle" content-class="esi-modal" size="lg"  
            :header-bg-variant="headerBgVariant" no-close-on-esc no-close-on-backdrop hide-header-close >

            <div v-if="participants.length >= 1">
                <div  class="text-center" v-for="(participant, index) in participants" :key="index">             
                    <div class="text-center">
                        {{ participant.firstname }} {{ participant.lastname }}
                    </div>
                    <div class="img-fluid">
                        <img :src="baseURL(participant.image)" class="participant-image">
                    </div>
                </div>

            </div>

            <div class="modal-body" v-else-if="participants.length <= 0">
                <div id="waiting" class="text-center">

                    <div v-if="waitingTimer <= 0"> 
                        <span class="text-primary small">
                            <div class="py-2">We are resending student a lesson another invitation, please wait...</div>
                            <b-spinner v-for="variant in variants" :variant="variant" :key="variant"></b-spinner>  
                        </span>
                    </div>
                    <div v-else>

                        <div class="pb-3 alert" role="alert">
                        
                            <div class="text-primary small" v-if="is_broadcaster == true">  
                                <div v-if="isDisconnected == false">                           
                                    Invite recieved, Please wait for the student to accept and connect...                            
                                </div>
                                <div v-if="isDisconnected == true">  
                                    <div>Please wait for the student to connect...</div>
                                    <b-spinner v-for="variant in variants" :variant="variant" :key="variant"></b-spinner>     
                                </div> 
                            </div>

                            <span class="text-primary small" v-if="is_broadcaster == false">

                                <div v-if="isDisconnected == false">                           
                                    
                                    <div class="py-2">Please wait for your tutor to connect... </div>

                                    <div v-if="this.supportCountdownTimer >= 1">
                                        <div class="py-2">Technical support will assist you in {{ this.supportCountdownTimer }} seconds when you are not connected</div>
                                        <b-spinner v-for="variant in variants" :variant="variant" :key="variant"></b-spinner>    
                                    </div>
                                    <div v-else-if="this.supportCountdownTimer == 0">
                                        <div class="py-2">Opening Chat Support, please wait... </div>
                                        <b-spinner v-for="variant in variants" :variant="variant" :key="variant"></b-spinner>    
                                    </div>
                                    <div v-else>
                                        <div class="mt-3">
                                            <b-button pill variant="primary" @click="contactCustomerSupport">
                                                <span class="small">Click here to contact constumer support</span>
                                            </b-button>
                                        </div>     
                                    </div>
                                </div>

                                <div v-if="isDisconnected == true">

                                    Please wait for the tutor to reconnect...  

                                    <div v-if="showTechnicalSupportLink == false">
                                        <div v-if="this.supportCountdownTimer >= 1">
                                            <div class="py-2">Technical support will assist you in {{ this.supportCountdownTimer }} when you are not connected</div>
                                            <b-spinner v-for="variant in variants" :variant="variant" :key="variant"></b-spinner>    
                                        </div>
                                        <div v-else>
                                             <div class="py-2">Opening Chat Support, please wait... </div>
                                            <b-spinner v-for="variant in variants" :variant="variant" :key="variant"></b-spinner>    
                                        </div>

                                    </div>

                                    <div class="mt-3" v-else-if="showTechnicalSupportLink == true">
                                        <b-button pill variant="primary" @click="contactCustomerSupport">
                                            <span class="small">Click here to contact constumer support</span>
                                        </b-button>
                                    </div>

                                </div>
                            </span>          
                        </div>
                                              
                    </div>
                </div>
            </div>


            <template #modal-footer>
                <div class="container text-center"  v-if="is_broadcaster == true">
                    <div v-if="participants.length <= 0">                        
                        <div v-if="waitingTimer <= 0"> Redialing, Please wait </div>                        
                        <div v-else> Redialing in {{ waitingTimer }} seconds </div>
                    </div>
                    <div v-else>
                        <div v-if="isLessonTimeStarted == true">
                            Lesson will start {{ lessonStartTimer }}
                        </div>
                        <div v-if="isLessonTimeStarted == false">
                            Please wait for your student to connect. 
                        </div>
                    </div>
                </div>

                <div class="container text-center"  v-if="is_broadcaster == false">
                    <div v-if="participants.length <= 0">
                       
                        <div v-if="isDisconnected == false">                           
                            Please wait for your tutor to connect...              
                        </div>
                        <div v-if="isDisconnected == true">                                     
                            Please wait for the tutor to reconnect...  
                        </div>

                    </div>
                    <div v-else>
                      
                        <div v-if="isLessonTimeStarted == true">
                            Lesson will start {{ lessonStartTimer }}
                        </div>
                        <div v-if="isLessonTimeStarted == false">
                           Please wait for your teacher to connect.                
                        </div>

                    </div>
                </div>

            </template>

        </b-modal>


   

    </div>
   
</template>

<style scoped>

    .participant-image {
        max-width:  175px;
        border-radius: 100px;
    }

</style>

<script>
export default {
    name: "TutorSessionInvite",
    components: {},
    props: {        
        is_broadcaster: Boolean,	
        lesson_history: Object,
        reservation: Object,
        csrf_token: String,		
        api_token: String,      
    },    
    data() {
        return {
            headerBgVariant: 'lightblue',

            expiredModalTitle:   '',
            expiredModalMessage: '',

            userPromptTitle: '',
            userPromptMessage: '',

            //Call waiting (Absent time)
            callWaitingLimit: null, //default time

            absentStartTime: null,
           

            loaded: false,
            variants: ['primary'],
            modalTitle: null,
            participants: [],          

            timerSpeed: 1000,

            callAttemptFailed: false,
            timeLimitExpired: false,

            callRedialInterval: null,            
            redialTimer: 8, //5 seconds (countdown), (3 seconds to waiting time to connect)
            redialCounter: 10,

            isLessonTimeStarted: false,
            lessonStartInterval: null,
            lessonStartTimer: 3,

            /******** WAITING TIMER  */
            waitingInterval: null,
            waitingTimer: 15,
            waitingRedialCounter: 10, //

            specificDate: null,
            expiredLessonDate: null,
            currentDate: null,


            //Support link timer (15 seconds)
            isSupportTimerStarted: false,
            supportTimerInterval: false,
            supportCountdownTimer: 15,


            //Determin if user has been disconnected
            isDisconnected: false,

            showTechnicalSupportLink: false,

        }
    },
    mounted() { 

        this.specificDate = new Date( this.reservation.lesson_time);
        // Add 15 minutes to the specific date and time
        this.specificDate.setTime(this.specificDate.getTime() + (15 * 60 * 1000));

        this.expiredLessonDate = new Date( this.reservation.lesson_time);
        
        // Add 30 minutes to the specific date and time
        this.expiredLessonDate.setTime(this.specificDate.getTime() + (30 * 60 * 1000));

        // Get the current date and time
        this.currentDate = new Date();

        if (this.is_broadcaster) {
            this.modalTitle = "Waiting for your student to join..";
        } else {
            this.modalTitle = "Waiting for your tutor to join..";
        }

        
    },
    methods: {
    
        /***************************************************** 
                SHOW WAITING MODAL  FOR PARTICIPANTS
        *****************************************************/
        showWaitingListModal() {         
            this.isLessonTimeStarted = false;  
            this.$bvModal.show('show-modal-participants');
        },
        hideWaitingListModal() {   
            this.isLessonTimeStarted = false;
            this.startLessonStartTimer();    
            //this.$bvModal.hide('show-modal-participants');                        
        },
        quickHideWaitingListModal() {
            this.$bvModal.hide('show-modal-participants');    
        },
        startLessonStartTimer() {
            this.isLessonTimeStarted = true;
            this.lessonStartInterval = setInterval(this.updateLessonTimer, this.timerSpeed);
            this.stopWaitingTimer();
        },
                
        stopLessonTimer() {
            this.resetLessonTimer();
            this.isLessonTimeStarted = false;
            clearInterval(this.lessonStartInterval);
        },           
        resetLessonTimer() {
            this.isLessonTimeStarted = false;
            this.lessonStartTimer = 3;
        }, 
        updateLessonTimer() {
            
            this.lessonStartTimer--;
            this.$forceUpdate();

            if (this.lessonStartTimer <= 0) {
                this.$bvModal.hide('show-modal-participants');
                this.stopLessonTimer();  
                this.stopWaitingTimer();              
            }
        },    
        /***************************************************** 
               "redialUser"  WAITING TIMER (15 seconds)   
        *****************************************************/
        resetWaitingTimer() {
            ///waiting timer for tutor to make an "emit" a "redialUser"
            this.stopWaitingTimer();
            this.waitingTimer = 15;            
        },
        stopWaitingTimer() {
            clearInterval(this.waitingInterval);
        },         
        startWaitingTimer() {

            if (this.$props.is_broadcaster == true) {

                console.log("start waiting timer", this.waitingTimer, this.$props.is_broadcaster )

                this.waitingInterval = setInterval(() => {
                    this.waitingTimer--;

                    console.log("waiting timer", this.waitingTimer);

                    if (this.waitingTimer < 0) {
                        this.$root.$emit('redialUser', this.participants);   
                        this.resetWaitingTimer();
                        this.waitingRedialCounter--;                           
                    }                   
                }, this.timerSpeed)       

            } else {
            
                this.resetSupportCountdownTimer();
                this.startSupportCountdownTimer();

                console.log("waiting timer of user is in progress")
            }     
        },         

        /***************************************************** 
                SHOW WAITING MODAL TIMER
        *****************************************************/
        resetRedialTimer() {
            this.redialTimer = 8;            
        },        
        stopRedialTimer() {
           clearInterval(this.callRedialInterval);
        },        
        startRedialTimer() 
        {
            this.callRedialInterval = setInterval(() => 
            {
                this.redialTimer--;

                if (this.redialTimer < 0) {

                    this.$root.$emit('redialUser', this.participants);   


                    this.resetRedialTimer();

                    // Compare the two dates to see if the current time is after 15 minutes from the specific date and time
                    if (this.currentDate.getTime() > this.specificDate.getTime()) {
                        console.log('The current time is after 15 minutes from the specific date and time.');                        
                        this.timeLimitExpired = true;
                        this.stopRedialTimer();
                    } else {
                   
                        console.log('The current time is not yet after 15 minutes from the specific date and time.');
                    }
                 
                }
                //console.log(this.redialTimer);

            }, this.timerSpeed)   
        },        


        /***************************************************** 
                CALL USER MODAL 
        *****************************************************/
        showCallUserModal(WaitingTimeLimit) {
            this.$bvModal.show('modal-call-user');
            this.startRedialTimer();
        },
        hideCallUserModal() {
            this.$bvModal.hide('modal-call-user');  
            this.resetRedialTimer();   
            this.stopRedialTimer();        
        },

        triggerLimitOverrideAndCallUser()
        {
            this.$bvModal.hide('modal-user-absent');

            this.$root.$emit('triggerLimitOverrideAndCallUser');
        },

        triggerContinueSession() {
            this.$bvModal.hide('modal-expired-options');

            //continue session will call user to test if it is in session
            this.$root.$emit('triggerCallUser');
        },
        triggerEndSession() {            
            this.$root.$emit('triggerEndSession');
        },


        /***************************************************** 
                ABSENT 
        *****************************************************/
        markStudentAbsent() {
            console.log("marking student as absent");
            this.$root.$emit('triggerMarkStudentAbsent');
            //@todo: Mark student absent       
        },
        showModalAbsent(params) { 
            console.log('showModalAbsent', params)
            this.userPromptTitle = params.title;
            this.userPromptMessage = params.message;       
            this.callWaitingLimit = params.callWaitingLimit;   
            this.$bvModal.show('modal-user-absent');
        },        
        hideModalAbsent() {
            this.userPromptTitle = params.title;
            this.userPromptMessage = params.message;        
            this.$bvModal.hide('modal-user-absent');
        },


        /***************************************************** 
                EXPIRED with OPTIONS (STARTED LESSON) 
        *****************************************************/
        showSessionExpiredOptionsModal(params) {
            this.expiredModalTitle = params.title;
            this.expiredModalMessage = params.message;
            this.$bvModal.show('modal-expired-options');
        },        
        hideModalExpiredOptionsModal() {
            this.$bvModal.hide('modal-expired-options');
        },

        /***************************************************** 
                EXPIRED (LESSON NOT STARTED) 
        *****************************************************/
        showModalExpired(params) {
            this.expiredModalTitle = params.title;
            this.expiredModalMessage = params.message;
            this.$bvModal.show('modal-expired');
        },        
        hideModalExpired() {
            this.$bvModal.hide('modal-expired');
        },

        showModalCompleted() {       
            this.$bvModal.show('modal-completed');
        },
        hideModalCompleted() {
            this.$bvModal.hide('modal-completed');
        },

        showUserPromptModal(params) {
            this.userPromptTitle = params.title;
            this.userPromptMessage = params.message;         
            this.$bvModal.show('modal-user-prompt'); 
        },
        hideUserPromptModal() {
            this.$bvModal.hide('modal-user-prompt');
        },

        backToMemberHome() {
            if (this.$props.is_broadcaster == true) {
                window.location.assign(this.baseURL('/admin'));            
            } else {
                window.location.assign(this.baseURL('/home'));            
            }
        },
        
        contactCustomerSupport() {
            this.$root.$emit('openCustomerSupport');
        },
        
        /***************************************************** 
                Support Countdown timer
        *****************************************************/
        startSupportCountdownTimer() {
        
            this.stopSupportCountdownTimer();
            this.resetSupportCountdownTimer();

            this.showTechnicalSupportLink = false;

            if (this.isSupportTimerStarted == false) {
                this.isSupportTimerStarted = true;
            } else {
            
            }

            if (this.isSupportTimerStarted == true) {
                this.supportTimerInterval = setInterval(()=> {
                    this.supportCountdownTimer --;  
                    if (this.supportCountdownTimer < 0) {  
                        //@todo: trigger customer support module
                        this.stopSupportCountdownTimer();
                        this.showTechnicalSupportLink = true;
                    }
                }, this.timerSpeed);  
            }
        },
        resetSupportCountdownTimer() {
            this.supportCountdownTimer = 15;
        },        
        stopSupportCountdownTimer() {
            
            //console.log("stop support timer triggered...")
            this.isSupportTimerStarted = false;
            clearInterval(this.supportTimerInterval); 
        },


        /***************************************************** 
                    PARTICIPANTS
        *****************************************************/        
        addParticipants(user) {
            this.resetLessonTimer();
            this.stopLessonTimer();
            if (this.participants.length == 0) {
                this.participants.push(user);
                if (this.participants >= 1) {
                    this.showWaitingListModal();
                    //this.startLessonStartTimer();
                } 
            } else {
                let result = this.participants.find(participant => participant.userid === user.userid);
                if (result) {
                    this.showWaitingListModal();
                    //this.startLessonStartTimer();
                }
            }
        },

        removeParticipants(user) {

            this.isDisconnected = true;

            for (var i in this.participants) {

                if (this.participants[i].userid === user.userid) {

                    console.log(this.participants[i], "- left the session");  
                    this.participants.splice(i);
                    
                    this.resetWaitingTimer();
                    this.stopWaitingTimer();

                    /**
                    ** @date: MARCH: 28. 2023
                    ** @todo: Start Support Countdown For members only 
                    **/
                    this.resetSupportCountdownTimer();
                    this.stopSupportCountdownTimer();
                    this.startSupportCountdownTimer();

                    this.$forceUpdate();
                    break;
                }
            }
        },
        baseURL(path) {
            return window.location.origin + path
        }
        
    }    
}
</script>